import {useState} from "react";
import {RowPerPageSize} from "@app/constants/types";

const PageableViewModel = (initRowPerPage?: number) => {
    const [page, setPage] = useState<number>(1);
    const [rowPerPage, setRowPerPage] = useState<number>(initRowPerPage || RowPerPageSize[1]);

    const onPage = (page: number) => {
        setPage(page);
    }

    const onRowPerPage = (perPage: number) => {
        setRowPerPage(perPage);
        setPage(1);
    }

    return {
        page,
        rowPerPage,
        onPage,
        onRowPerPage
    }
}

export default PageableViewModel;
